module.exports = __webpack_public_path__ + "img/offline.7005f32f.svg";